<template>
  <div id="app3">
      <Carousel_cards :vertical='false' :verticalS='false' :items='4' :rows='1' :controls='false' :texts="texts" :names="names" />
  </div>
</template>

<script>
import Carousel_cards from './components/Carousel_cards';

export default {
  name: 'AppS',
  components: {
    Carousel_cards,
  },
  data: () => ({
   texts:[
      'Τελείωσα σήμερα τη θεραπεία μου με Ι131 στο Νοσοκομείο "Οι Άγιοι Ανάργυροι" και θέλω να σας τα μεταφέρω πολλά συγχαρητήρια ιατί σας ανήκουν και να σας ευχαριστήσω και πάλι για την ανεκτίμητη βοήθεια σας.',
      'Θα ήθελα να σας μεταφέρω τις μεγάλες ευχαριστίες και την ευγνωμοσύνη της οικογένειας προς το Ιατρικό και νοσηλευτικό προσωπικό του νοσοκομείου για όλες τις άριστες και επιμελείς υπηρεσίες τους.',
      "Θα ήθελα να συγχαρώ τον Διευθυντή της Α' Χειρουργικής Κλινικής του ΚΑΤ, Δρ. Ιωάννη Παρασκευόπουλο, ο οποίος με χειρούργησε. Ο Δρ. Παρασκευόπουλος έδειξε συγκινητική φροντίδα από την πρώτη στιγμή της νοσηλείας μου.",
      'Ο Δρ. Παρασκευόπουλος, μαζί με τους χειρουργούς του, τις αναισθησιολόγους και τις νοσηλεύτριες του χειρουργίου έσωσαν την ζωή μου και με επανέφεραν στην ζωή από την συψαιμία που με είχε χτυπήσει.',
      'Εκ μέρους της Ελληνικής Ομοσπονδίας Ιπασσίας, θα θέλαμε να σας εκφράσουμε τις θερμές μας ευχαριστίες και την ευγνωμοσύνη μας για την υψηλού επιπέδου περίθαλψη και φροντίδα που παρέχατε στην αθλήτρια μας Ελένη Πυρού.'
    ],
    names:[
      'Mireille T.',
      'Eleni A.',
      'Apostolos A.',
      'Ioannis D.',
      'Eleni P.'
    ],
    })
}
</script>

